module.exports = __webpack_public_path__ + "assets/img/label-classify-5.aa59f817.png";